import React from 'react';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  createSearchParams,
  useSearchParams,
} from 'react-router-dom';
import { routes } from './common/routes';
import SystemClient from './system/SystemClient';
import Environment from './lib/Environment';
import MessageCourier from './lib/MessageCourier';
import BasicBlockUI from './Components/Common/BasicBlockUI';
import XhrRequestError from './lib/XhrRequestError';
import XhrErrorListener from './lib/XhrErrorListener';
import { Home } from './Components/Home';
import { NotFound } from './Components/NotFound';
import Base from './Components/Common/Layout/Base';
import ConfeccionPlanillaPartido from './Components/PlanillaPartido/Programado/Confeccion/ConfeccionPlanillaPartido';
import PlanillaDigitalView from './Components/PlanillaDigital/PlanillaDigitalView';
import { PlanillaPartido } from './system/PlanillaPartido/PlanillaPartido';
import PlanillaPartidoProgramadoListController from './Components/PlanillaPartido/Programado/PlanillaPartidoProgramadoListController';
import useAsyncDataFull from './common/custom-hooks/useAsyncDataFull';
import PlanillaDigitalViewController from './Components/PlanillaDigital/PlanillaDigitalViewController';
import PlanillaPartidoOfflineViewController from './Components/PlanillaPartidoOffline/PlanillaPartidoOfflineViewController';
import { useTheme } from '@fluentui/react';

interface IRouterContextProps {
  system: SystemClient;
  environment: Environment;
  courier: MessageCourier;
  changeTheme: () => void;
}

class ErrorListener implements XhrErrorListener {
  constructor(private onAuthenticationError: (error: XhrRequestError) => void) {}

  receiveError(error: XhrRequestError): void {
    console.log('error :>> **', error);
    if (error.isAuthenticationRequiredError()) {
      this.onAuthenticationError(error);
    }
  }
}

const AppInRouterContext = (props: IRouterContextProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [block, setBlock] = React.useState(false);
  const [errorListener, setErrorListener] = React.useState<ErrorListener>();

  const [planillaPartido, setPlanillaPartido] = React.useState<PlanillaPartido | undefined>(undefined);
  const [isPartidoOnline, setIsPartidoOnline] = React.useState<boolean>(true);

  const changeBlockUI = (shouldBlock: boolean) => {
    setBlock(shouldBlock);
  };

  const {
    data: user,
    loaded,
    loading,
  } = useAsyncDataFull(
    () =>
      location.pathname == props.environment.getLocalBasePath() || location.pathname == '/'
        ? Promise.resolve(undefined)
        : props.system.userData(),
    [location, props.system],
    undefined,
    changeBlockUI
  );

  const theme = useTheme();
  return (
    <>
      <BasicBlockUI blockUI={block} />
      <Routes>
        <Route
          path="/"
          element={
            <Base
              user={user}
              courier={props.courier}
              system={props.system}
              changeBlockUI={changeBlockUI}
              changeTheme={props.changeTheme}
              theme={theme}
            />
          }
        >
          <Route index element={<Home user={user} system={props.system} />} />
          {user && (
            <Route path={routes.planilla_partido_programado.route}>
              <Route
                index
                element={
                  <PlanillaPartidoProgramadoListController
                    courier={props.courier}
                    changeBlockUI={changeBlockUI}
                    system={props.system}
                    user={user}
                    setIsPartidoOnline={(p: boolean) => setIsPartidoOnline(p)}
                    setPlanillaPartido={(p: PlanillaPartido | undefined) => setPlanillaPartido(p)}
                  />
                }
              />
              <Route
                path=":id"
                element={
                  <ConfeccionPlanillaPartido
                    system={props.system}
                    courier={props.courier}
                    changeBlockUI={changeBlockUI}
                    user={user}
                    setPlanillaPartido={(p: PlanillaPartido) => setPlanillaPartido(p)}
                  />
                }
              />
            </Route>
          )}
          {/* {planillaPartido && ( */}
          <Route path={routes.planilla_partido.route}>
            <Route
              path=":id"
              element={
                <PlanillaDigitalViewController
                  system={props.system}
                  courier={props.courier}
                  changeBlockUI={changeBlockUI}
                  user={user}
                  planillaPartido={planillaPartido}
                  isPartidoOnline={isPartidoOnline}
                  environment={props.environment}
                />
              }
            />
          </Route>
          {/* )} */}
          <Route path={routes.planilla_partido_offline.route}>
            <Route
              index
              element={
                <PlanillaPartidoOfflineViewController
                  courier={props.courier}
                  changeBlockUI={changeBlockUI}
                  system={props.system}
                  setPlanillaPartido={(p: PlanillaPartido) => setPlanillaPartido(p)}
                  setIsPartidoOnline={(p: boolean) => setIsPartidoOnline(p)}
                />
              }
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppInRouterContext;
